export const LEAD_SLIDE_UP_MODAL_ID = 'lead-slide-up-modal';
